import $ from 'jquery';
import Swiper from 'swiper';

$(() => {
    const partnersSlider = new Swiper('.gallery-swiper', {
        loop: true,
        centeredSlides: true,
        autoplay: {
            delay: 0,
            disableOnInteraction: false,
        },




        speed: 5000,

        slidesPerView: 2,
        breakpoints: {
            576: {
                slidesPerView: 3,
            },
            992: {
                slidesPerView: 4,
            },
            1200: {
                slidesPerView: 5,
            },


        },

    });
});
